import * as tslib_1 from "tslib";
import * as React from 'react';
import { setFeatureFlag } from 'owa-feature-flags';
import { observer } from 'mobx-react';
import { Toggle } from 'office-ui-fabric-react/lib/components/Toggle';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var styles = require('./FeatureFlagsListItem.scss');
var classNames = require('classnames/bind');
var FeatureFlagsListItem = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsListItem, _super);
    function FeatureFlagsListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsListItem.prototype.render = function () {
        var _a = this.props, name = _a.name, isOn = _a.isOn;
        return (React.createElement(Toggle, { checked: isOn, onText: name, offText: name, className: classNames(styles.toggle, isControlFeatureEnabled('fwk-o365shellheader') && styles.noDark), onChanged: function (value) { return setFeatureFlag(name, !isOn); } }));
    };
    FeatureFlagsListItem = tslib_1.__decorate([
        observer
    ], FeatureFlagsListItem);
    return FeatureFlagsListItem;
}(React.Component));
export default FeatureFlagsListItem;
//# sourceMappingURL=FeatureFlagsListItem.js.map